const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.72,160.48s-16.87-67.66-119-110.33S111.22,47,90.39,97s1,77-12.9,119.7S-7.82,313.48,21,379.06s163.68,84.31,272.81,70.78S488.2,286.42,423.72,160.48Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.72,160.48s-16.87-67.66-119-110.33S111.22,47,90.39,97s1,77-12.9,119.7S-7.82,313.48,21,379.06s163.68,84.31,272.81,70.78S488.2,286.42,423.72,160.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158,106.58H75a10,10,0,0,0-10,10v31a10,10,0,0,0,10,10h82.5l10.5,14v-55A10,10,0,0,0,158,106.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07,140.71h-3v-19h3v8.13h3.38v-8.13h3v19h-3v-8.13H83.07Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,121.74h3v19h-3Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14,121.74h9.21v2.71h-3.12v16.26h-3V124.45h-3.11Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,140.71h-3v-19h3v8.13H117v-8.13h3v19h-3v-8.13h-3.39Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,129.73h4.09v2.71H125.2V138h5.15v2.71h-8.13v-19h8.13v2.71H125.2Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42,140.71a5.92,5.92,0,0,1-.27-2.33v-3c0-1.76-.59-2.41-2-2.41h-1v7.72h-3v-19h4.5c3.09,0,4.42,1.44,4.42,4.36v1.49c0,1.95-.63,3.23-2,3.85,1.49.63,2,2.06,2,4v2.93a5.53,5.53,0,0,0,.33,2.3Zm-3.25-16.26v5.83h1.17c1.11,0,1.79-.49,1.79-2V126.4c0-1.35-.46-2-1.52-2Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.07,129.73h4.09v2.71h-4.09V138h5.14v2.71h-8.13v-19h8.13v2.71h-5.14Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.44,136.51l-.38-6.86v-7.91h3v7.91l-.38,6.86Zm2.54,1.33v2.87h-2.87v-2.87Z",
    style: {
      fill: "#219297"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298,107.58s-3.7-1.31-4.54,2,4.06,4.54,4.66,4.54,1.55-.83.95-2.74S298,107.58,298,107.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,99.46s-.36,4.78-.36,6.69,2,2.63,3,2.63,1.44,2.27.84,4.66-2.63,3.82-7.53,3.82-7.88-2.15-8-3.7,1.07-8.25,3.11-10S319,99.46,319,99.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.11,114.15V116a1.52,1.52,0,0,0,.89,1.38,8.51,8.51,0,0,0,2.7.65,12.83,12.83,0,0,0,5.42-1.2,1.3,1.3,0,0,0,.79-1.2v-1.93a.72.72,0,0,0-1-.65l-.39.2S303.62,114,301.11,114.15Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.49,98.5a50.45,50.45,0,0,0-1.32,8c-.36,4.42,0,8.48,1.79,8.6a6.48,6.48,0,0,0,3.47-1s4.18.48,5.61-.23l1.44-.72,1.07-7s.12-10.87-1.91-11.59S298.49,98.5,298.49,98.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.71,103.4l-.95,2.51s-1.92.48-1.68,1.43,1.51.81,1.51.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.78,104.49c-.19.52-.58.86-.85.76s-.35-.61-.15-1.14.58-.87.86-.76S305,104,304.78,104.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.28,103.28c-.2.53-.58.87-.86.77s-.34-.62-.15-1.14.58-.87.86-.77S300.47,102.76,300.28,103.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.86,101.13s2.27-.6,2.51,1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.88,100.53s-2-.71-2.63,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.43,
    y1: 114.15,
    x2: 305.65,
    y2: 112.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,93s-3.82-4.54-6.69-1.2-2,8.37,3.11,8.61,10.87-4.78,10.87-4.78-.6,6.57.83,8.84,2.51,3.82,2.51,3.82,2,1.31,5.38-1.31,4.18-9,1.79-13.27-6.57-6.69-11.59-5S300,93,300,93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,108.18s4.3-3.94,4.3-1.67-2,4.3-3.58,3.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.08,110a3.32,3.32,0,0,0,3.88,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.57,
    cy: 103.74,
    r: 20.19,
    transform: "translate(21.02 256.09) rotate(-46.78)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.1,
    cy: 247.19,
    r: 21.34,
    transform: "translate(-44.75 106.46) rotate(-13.16)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38,253.48a7.1,7.1,0,1,1-7.1-7.1A7.1,7.1,0,0,1,446.38,253.48Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.43,258.21a13,13,0,1,0-20.29,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.35,254.53H433.89a4.66,4.66,0,0,1-4.66-4.66h0a4.65,4.65,0,0,1,4.66-4.66h10.46a4.65,4.65,0,0,1,4.66,4.66h0A4.66,4.66,0,0,1,444.35,254.53Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,249.49a3.16,3.16,0,0,1,5.89-.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15,249.49a3.16,3.16,0,0,1,5.89-.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.57,251.65a1.79,1.79,0,0,0,3.56,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.09,252.39h0a1.36,1.36,0,0,1-1.36-1.36v-3.09a1.36,1.36,0,0,1,1.36-1.36h0a1.36,1.36,0,0,1,1.36,1.36V251A1.36,1.36,0,0,1,456.09,252.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,252.39h0a1.36,1.36,0,0,1-1.36-1.36v-3.09a1.36,1.36,0,0,1,1.36-1.36h0a1.36,1.36,0,0,1,1.36,1.36V251A1.36,1.36,0,0,1,422.11,252.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.62,248.13a1.43,1.43,0,0,1-1.42-1.43v-2.24a12.12,12.12,0,0,1,2.08-6.81,1.43,1.43,0,1,1,2.36,1.6,9.27,9.27,0,0,0-1.59,5.21v2.24A1.43,1.43,0,0,1,424.62,248.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,239.17a.7.7,0,0,1-.59-.32,10,10,0,0,0-8.33-4.43h-7.94a10,10,0,0,0-8.33,4.43.72.72,0,0,1-1,.19.71.71,0,0,1-.19-1,11.45,11.45,0,0,1,9.51-5.06h7.94a11.46,11.46,0,0,1,9.52,5.07.71.71,0,0,1-.2,1A.72.72,0,0,1,452.24,239.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.08,248.13a1.43,1.43,0,0,1-1.43-1.43v-2.24a9.27,9.27,0,0,0-1.59-5.21,1.43,1.43,0,1,1,2.37-1.59,12.08,12.08,0,0,1,2.07,6.8v2.24A1.43,1.43,0,0,1,454.08,248.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,254.41h0a2.82,2.82,0,0,1-2.82-2.82v-4.48a2.82,2.82,0,0,1,2.82-2.82h0a2.82,2.82,0,0,1,2.82,2.82v4.48A2.82,2.82,0,0,1,424.8,254.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.51,
    y: 244.29,
    width: 0.58,
    height: 10.12,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.74,
    y: 244.29,
    width: 5.64,
    height: 10.12,
    rx: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.27,
    y: 244.29,
    width: 0.58,
    height: 10.12,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.33,243.37h0a6,6,0,0,0,5-2.72l1.23-1.91a12.95,12.95,0,0,0-12.72.1l1.84,2.3A6,6,0,0,0,439.33,243.37Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.43,
    cy: 255.47,
    r: 0.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.64,256.2a.21.21,0,0,0-.21-.2.2.2,0,0,0-.21.2.21.21,0,0,0,.21.21A.21.21,0,0,0,439.64,256.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,256.09a.21.21,0,0,0,.14-.26.23.23,0,0,0-.27-.14.21.21,0,0,0-.14.26A.23.23,0,0,0,438.81,256.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,256.09a.21.21,0,0,0,.14-.26.22.22,0,0,0-.27-.14.2.2,0,0,0-.13.26A.21.21,0,0,0,440.12,256.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.88 138.15 333.31 138.15 333.31 102.7 333.31 93.3 342.72 102.7 412.88 102.7 412.88 138.15",
    style: {
      fill: "#d6d6d6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.88 189.5 333.31 189.5 333.31 154.06 333.31 144.66 342.72 154.06 412.88 154.06 412.88 189.5",
    style: {
      fill: "#d6d6d6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 114.9,
    x2: 405.17,
    y2: 114.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 114.9,
    x2: 381.63,
    y2: 114.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 114.9,
    x2: 356.48,
    y2: 114.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 120.79,
    x2: 405.17,
    y2: 120.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 120.79,
    x2: 373.07,
    y2: 120.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 126.67,
    x2: 405.17,
    y2: 126.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 126.67,
    x2: 395.54,
    y2: 126.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 126.67,
    x2: 365.58,
    y2: 126.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 164.65,
    x2: 405.17,
    y2: 164.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 164.65,
    x2: 381.63,
    y2: 164.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 164.65,
    x2: 356.48,
    y2: 164.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 170.54,
    x2: 405.17,
    y2: 170.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 170.54,
    x2: 373.07,
    y2: 170.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 176.42,
    x2: 405.17,
    y2: 176.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 176.42,
    x2: 395.54,
    y2: 176.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 176.42,
    x2: 365.58,
    y2: 176.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.31 333.91 412.88 333.91 412.88 248.18 412.88 238.78 403.47 248.18 333.31 248.18 333.31 333.91",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 259.88,
    x2: 405.17,
    y2: 259.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 259.88,
    x2: 381.63,
    y2: 259.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 259.88,
    x2: 356.48,
    y2: 259.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 265.76,
    x2: 405.17,
    y2: 265.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 265.76,
    x2: 373.07,
    y2: 265.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 271.65,
    x2: 405.17,
    y2: 271.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 271.65,
    x2: 395.54,
    y2: 271.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 271.65,
    x2: 365.58,
    y2: 271.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 276.46,
    x2: 405.17,
    y2: 276.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 276.46,
    x2: 381.63,
    y2: 276.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 276.46,
    x2: 356.48,
    y2: 276.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 282.35,
    x2: 405.17,
    y2: 282.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 282.35,
    x2: 373.07,
    y2: 282.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 288.23,
    x2: 405.17,
    y2: 288.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 288.23,
    x2: 395.54,
    y2: 288.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 288.23,
    x2: 365.58,
    y2: 288.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 293.05,
    x2: 405.17,
    y2: 293.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 293.05,
    x2: 381.63,
    y2: 293.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 293.05,
    x2: 356.48,
    y2: 293.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 298.93,
    x2: 405.17,
    y2: 298.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 298.93,
    x2: 373.07,
    y2: 298.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 304.82,
    x2: 405.17,
    y2: 304.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 304.82,
    x2: 395.54,
    y2: 304.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 304.82,
    x2: 365.58,
    y2: 304.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 309.63,
    x2: 405.17,
    y2: 309.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 309.63,
    x2: 381.63,
    y2: 309.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 309.63,
    x2: 356.48,
    y2: 309.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 315.52,
    x2: 405.17,
    y2: 315.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 315.52,
    x2: 373.07,
    y2: 315.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 321.4,
    x2: 405.17,
    y2: 321.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 321.4,
    x2: 395.54,
    y2: 321.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 321.4,
    x2: 365.58,
    y2: 321.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.1,
    cy: 360.24,
    r: 21.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38,366.53a7.1,7.1,0,1,1-7.1-7.09A7.1,7.1,0,0,1,446.38,366.53Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.43,371.26a13,13,0,1,0-20.29,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.35,367.58H433.89a4.66,4.66,0,0,1-4.66-4.66h0a4.66,4.66,0,0,1,4.66-4.66h10.46a4.66,4.66,0,0,1,4.66,4.66h0A4.66,4.66,0,0,1,444.35,367.58Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,362.54a3.16,3.16,0,0,1,5.89-.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15,362.54a3.16,3.16,0,0,1,5.89-.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.57,364.7a1.79,1.79,0,0,0,3.56,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.09,365.44h0a1.36,1.36,0,0,1-1.36-1.36V361a1.36,1.36,0,0,1,1.36-1.36h0a1.36,1.36,0,0,1,1.36,1.36v3.09A1.36,1.36,0,0,1,456.09,365.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,365.44h0a1.36,1.36,0,0,1-1.36-1.36V361a1.36,1.36,0,0,1,1.36-1.36h0a1.36,1.36,0,0,1,1.36,1.36v3.09A1.36,1.36,0,0,1,422.11,365.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.62,361.19a1.43,1.43,0,0,1-1.42-1.43v-2.25a12.14,12.14,0,0,1,2.08-6.81,1.43,1.43,0,0,1,2.36,1.6,9.27,9.27,0,0,0-1.59,5.21v2.25A1.43,1.43,0,0,1,424.62,361.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,352.22a.72.72,0,0,1-.59-.31,10,10,0,0,0-8.33-4.44h-7.94a10.06,10.06,0,0,0-8.33,4.43.71.71,0,0,1-1.18-.8,11.45,11.45,0,0,1,9.51-5.06h7.94a11.48,11.48,0,0,1,9.52,5.07.71.71,0,0,1-.2,1A.72.72,0,0,1,452.24,352.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.08,361.19a1.43,1.43,0,0,1-1.43-1.43v-2.25a9.26,9.26,0,0,0-1.59-5.2,1.43,1.43,0,1,1,2.37-1.6,12.1,12.1,0,0,1,2.07,6.8v2.25A1.43,1.43,0,0,1,454.08,361.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.8,367.47h0a2.82,2.82,0,0,1-2.82-2.82v-4.49a2.82,2.82,0,0,1,2.82-2.82h0a2.82,2.82,0,0,1,2.82,2.82v4.49A2.83,2.83,0,0,1,424.8,367.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.51,
    y: 357.34,
    width: 0.58,
    height: 10.12,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.74,
    y: 357.34,
    width: 5.64,
    height: 10.12,
    rx: 2.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.27,
    y: 357.34,
    width: 0.58,
    height: 10.12,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.33,356.42h0a6,6,0,0,0,5-2.72l1.23-1.9a13,13,0,0,0-12.72.09l1.84,2.3A6,6,0,0,0,439.33,356.42Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.43,
    cy: 368.52,
    r: 0.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.43,
    cy: 369.26,
    r: 0.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,369.14a.21.21,0,0,0,.14-.26.23.23,0,0,0-.27-.14.22.22,0,0,0-.14.26A.21.21,0,0,0,438.81,369.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,369.14a.21.21,0,0,0,.14-.26.22.22,0,0,0-.27-.14.2.2,0,0,0-.13.26A.2.2,0,0,0,440.12,369.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.31 411.83 412.88 411.83 412.88 361.23 412.88 351.83 403.47 361.23 333.31 361.23 333.31 411.83",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 372.93,
    x2: 405.17,
    y2: 372.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 372.93,
    x2: 381.63,
    y2: 372.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 372.93,
    x2: 356.48,
    y2: 372.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 378.82,
    x2: 405.17,
    y2: 378.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 378.82,
    x2: 373.07,
    y2: 378.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 384.7,
    x2: 405.17,
    y2: 384.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 384.7,
    x2: 395.54,
    y2: 384.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 384.7,
    x2: 365.58,
    y2: 384.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.44,
    y1: 389.52,
    x2: 405.17,
    y2: 389.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.23,
    y1: 389.52,
    x2: 381.63,
    y2: 389.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 389.52,
    x2: 356.48,
    y2: 389.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.88,
    y1: 395.4,
    x2: 405.17,
    y2: 395.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 395.4,
    x2: 373.07,
    y2: 395.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.82,
    y1: 401.28,
    x2: 405.17,
    y2: 401.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.86,
    y1: 401.28,
    x2: 395.54,
    y2: 401.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.18,
    y1: 401.28,
    x2: 365.58,
    y2: 401.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,55.58H411.72a10,10,0,0,1-9.81,8.14h-59.1A10,10,0,0,1,333,55.58H291.77a13,13,0,0,0-13,13v349a13,13,0,0,0,13,13H453a13,13,0,0,0,13-13v-349A13,13,0,0,0,453,55.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,79.13V68.59a13,13,0,0,0-13-13H411.72a10,10,0,0,1-9.81,8.14h-59.1A10,10,0,0,1,333,55.58H291.77a13,13,0,0,0-13,13V79.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,65c0,2.56-2.88,3.48-2.89,5.43v.13h2.79v.87H292.1V70.7C292.1,68,295,67.42,295,65c0-.88-.29-1.34-1-1.34s-1,.5-1,1.25v.75h-.88V65c0-1.3.59-2.16,1.9-2.16S295.92,63.7,295.92,65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.56,65v.22a1.68,1.68,0,0,1-1,1.74,1.68,1.68,0,0,1,1,1.76v.65c0,1.3-.61,2.15-1.91,2.15s-1.91-.85-1.91-2.15v-.58h.89v.64c0,.77.31,1.23,1,1.23s1-.45,1-1.31v-.65c0-.84-.36-1.24-1.07-1.27H298v-.84h.56a1,1,0,0,0,1-1.17V65c0-.87-.31-1.32-1-1.32s-1,.47-1,1.24v.44h-.89V65c0-1.3.61-2.14,1.91-2.14S300.56,63.69,300.56,65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,65.63v1.18h-.91V65.63Zm0,4.62v1.18h-.91V70.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.31,66.39a1.37,1.37,0,0,1,1.26-.7c1.09,0,1.58.8,1.58,2v1.66c0,1.3-.62,2.15-1.92,2.15s-1.9-.85-1.9-2.15v-.57h.88v.63c0,.77.32,1.23,1,1.23s1-.46,1-1.23V67.78c0-.77-.31-1.23-1-1.23a.91.91,0,0,0-1,.91v.19h-.89l.23-4.71h3.35v.85h-2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,65v.15H311v-.22c0-.76-.32-1.21-1-1.21s-1,.46-1,1.37V67a1.36,1.36,0,0,1,1.37-.91c1.09,0,1.58.78,1.58,2v1.28c0,1.3-.64,2.15-1.94,2.15S308,70.66,308,69.36V65c0-1.35.6-2.19,1.95-2.19S311.86,63.68,311.86,65Zm-2.92,3.17v1.27c0,.77.32,1.23,1,1.23s1-.46,1-1.23V68.15c0-.76-.33-1.22-1-1.22S308.94,67.39,308.94,68.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.27,
    y: 65.35,
    width: 2.4,
    height: 5.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.47,
    y: 64.15,
    width: 2.4,
    height: 7.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.66,
    y: 63.3,
    width: 2.4,
    height: 8.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.86,
    y: 61.81,
    width: 2.4,
    height: 9.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.91,71.17H441.53V62.39h14.38Zm-13.58-.79h12.78V63.19H442.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.53,
    y: 64.06,
    width: 7.59,
    height: 5.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.41,
    y: 65.75,
    width: 1.81,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,69.26a.52.52,0,0,1-.27-.07c-2.93-1.74-4.86-.13-4.94-.06a.54.54,0,1,1-.71-.81c.1-.09,2.58-2.21,6.2-.06a.55.55,0,0,1,.18.74A.53.53,0,0,1,436.26,69.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34,67.46a.53.53,0,0,1-.27-.08c-4.23-2.51-7.08-.08-7.11-.06a.53.53,0,1,1-.7-.8s3.46-3,8.36-.06a.54.54,0,0,1,.18.74A.54.54,0,0,1,437.34,67.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.33,65.37a.57.57,0,0,1-.28-.08c-5.36-3.18-8.92-.18-9.07-.05a.54.54,0,0,1-.71-.81c.05,0,4.28-3.66,10.33-.06a.54.54,0,0,1,.19.74A.55.55,0,0,1,438.33,65.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.64,70.16a1.35,1.35,0,1,1-1.34-1.34A1.34,1.34,0,0,1,434.64,70.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-84"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 451,
    y1: 446.51,
    x2: 472,
    y2: 446.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 446.51,
    x2: 444,
    y2: 446.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.65,
    y1: 446.51,
    x2: 42,
    y2: 446.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.4,
    y: 311.84,
    width: 15.28,
    height: 132.8,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.3,
    y: 334.15,
    width: 9.34,
    height: 60.9,
    transform: "translate(-283.63 445.57) rotate(-90)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.44,
    y: 327.69,
    width: 9.34,
    height: 37.37,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67,365.22a8.55,8.55,0,0,1-8.56,8.55c-.28,0-.56,0-.83,0a8.56,8.56,0,1,1,9.13-10.66A8.89,8.89,0,0,1,60.67,365.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,333.45A8.57,8.57,0,0,1,52.74,342c-.28,0-.56,0-.84,0A8.56,8.56,0,1,1,61,331.32,8.29,8.29,0,0,1,61.3,333.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.64,
    y: 313.26,
    width: 14.14,
    height: 5.44,
    transform: "translate(-141.25 71.78) rotate(-28.3)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,315.56l-6.13,3.3-3.92-7.27,6.14-3.31A4.12,4.12,0,0,1,83,310h0A4.14,4.14,0,0,1,81.27,315.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.4 284.73 53.96 310.09 48.53 310 48.96 284.64 54.4 284.73",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.87,283.2l-.11,7L47.5,290l.11-7a4.13,4.13,0,0,1,4.2-4.06h0A4.12,4.12,0,0,1,55.87,283.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.72 293.93 62.79 316.31 57.99 313.76 69.91 291.38 74.72 293.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.72,293.24l-3.27,6.15-7.29-3.87,3.26-6.16A4.14,4.14,0,0,1,75,287.65h0A4.14,4.14,0,0,1,76.72,293.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.12 293.83 46.94 316.27 42.13 318.81 30.31 296.37 35.12 293.83",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.21,310.1a5.32,5.32,0,1,0-4.35,6.13A5.32,5.32,0,0,0,46.21,310.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.41,
    cy: 305.48,
    r: 5.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.77,308.55A5.32,5.32,0,1,0,62.71,313,5.31,5.31,0,0,0,68.77,308.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.67,291.78l3.26,6.16-7.3,3.87-3.26-6.17a4.12,4.12,0,0,1,1.72-5.58h0A4.14,4.14,0,0,1,35.67,291.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75,320.37a15,15,0,0,1-15,15c-.5,0-1,0-1.47-.06a15,15,0,1,1,16-18.69A15.39,15.39,0,0,1,67.75,320.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75,320.37a15,15,0,0,1-15,15c-.5,0-1,0-1.47-.06a15,15,0,0,1,14.55-18.76c.49,0,1,0,1.47.07A15.39,15.39,0,0,1,67.75,320.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.57,
    cy: 360.86,
    r: 20.24,
    transform: "translate(-255.95 398.98) rotate(-76.83)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.57,
    cy: 360.86,
    r: 9.81,
    transform: "translate(-129.4 75.39) rotate(-22.64)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,446.51h89.8l1.29-6.08A9.4,9.4,0,0,0,204,429.29c-12.73-2.86-40.29-3.89-40.29-3.89-6.64.21-25.12,1-37.85,3.9a9.4,9.4,0,0,0-7.1,11.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,426.88c-11.5-1.06-22.86-1.48-22.86-1.48-4.18.13-13.06.5-22.24,1.48,2.68,9.15,11.76,15.89,22.55,15.89S183.92,436,186.6,426.88Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.56,
    y: 351.23,
    width: 9.34,
    height: 60.9,
    transform: "translate(683.41 420.61) rotate(126.73)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.79,
    y: 394.85,
    width: 9.34,
    height: 37.37,
    transform: "translate(200.29 893.57) rotate(-143.27)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,393.32a8.57,8.57,0,0,1,12-1.74l.65.53a8.56,8.56,0,1,1-13.69,3.08A8.71,8.71,0,0,1,252.87,393.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.34,417.25a8.56,8.56,0,0,1,11.88-2.32c.23.15.45.32.67.49a8.56,8.56,0,1,1-13.52,3.75A8.66,8.66,0,0,1,233.34,417.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.88,
    y: 423.22,
    width: 14.14,
    height: 5.44,
    transform: "translate(387.22 870.86) rotate(-174.39)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,421l6.94.68-.81,8.22-6.94-.68a4.13,4.13,0,0,1-3.71-4.51h0A4.14,4.14,0,0,1,206.78,421Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,424.5a15,15,0,0,1,20.84-4.08c.41.28.8.57,1.18.88A15,15,0,1,1,219,427.87,14.78,14.78,0,0,1,220.68,424.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.52 440.08 223.12 426.17 226.11 430.16 207.51 444.06 204.52 440.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.59,439.87,207.7,436l4.54,6-5.11,3.83a3.78,3.78,0,0,1-5.29-.76h0A3.77,3.77,0,0,1,202.59,439.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.54,430.46a5.32,5.32,0,1,0-6.34,4A5.32,5.32,0,0,0,228.54,430.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.4 454.06 241.16 434.98 245.25 435.56 242.5 454.64 238.4 454.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,455.07l.75-5.25,6.21.89-.75,5.24a3.14,3.14,0,0,1-3.55,2.67h0A3.14,3.14,0,0,1,237.15,455.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,434.31a4.41,4.41,0,1,0-1.34,6.1A4.42,4.42,0,0,0,246.85,434.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.99 451.52 232.39 431.88 236.6 434.52 224.21 454.17 219.99 451.52",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,452l3.39-5.4,6.41,4-3.4,5.41a3.79,3.79,0,0,1-5.21,1.19h0A3.78,3.78,0,0,1,218.12,452Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,433.94a5.31,5.31,0,1,0-4.47,6A5.3,5.3,0,0,0,239,433.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.08,
    cy: 361.21,
    r: 20.24,
    transform: "translate(-162.88 168.51) rotate(-32.77)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.08,
    cy: 361.21,
    r: 9.81,
    transform: "translate(-208.74 397.05) rotate(-65.36)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.04,
    cy: 288.61,
    r: 32.51,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.52,310.26a59.48,59.48,0,1,0-93,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.98,
    y: 250.72,
    width: 90.62,
    height: 42.68,
    rx: 8.18,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.78,270.33a14.49,14.49,0,0,1,27-.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,270.33a14.49,14.49,0,0,1,27-.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,280.22a8.21,8.21,0,0,0,16.29,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,283.6h0a6.22,6.22,0,0,1-6.22-6.22V263.23A6.22,6.22,0,0,1,241,257h0a6.22,6.22,0,0,1,6.23,6.22v14.15A6.22,6.22,0,0,1,241,283.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.38,283.6h0a6.22,6.22,0,0,1-6.23-6.22V263.23A6.22,6.22,0,0,1,85.38,257h0a6.22,6.22,0,0,1,6.22,6.22v14.15A6.22,6.22,0,0,1,85.38,283.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32,219.75a49,49,0,0,0-8.42,27.54v10.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,219.79A49.22,49.22,0,0,0,182.52,198H146.17a49.21,49.21,0,0,0-40.85,21.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,257.57V247.29a49.06,49.06,0,0,0-8.38-27.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 14
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.78,
    y: 246.5,
    width: 25.82,
    height: 46.37,
    rx: 8.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.38,
    y: 246.5,
    width: 2.63,
    height: 46.37,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: 246.5,
    width: 25.82,
    height: 46.37,
    rx: 8.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: 246.5,
    width: 2.63,
    height: 46.37,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25,242.29h0a27.28,27.28,0,0,0,22.91-12.46l5.64-8.73a59.46,59.46,0,0,0-58.29.45L143,232.09A27.28,27.28,0,0,0,164.25,242.29Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,297.72a1,1,0,1,0-1,1A1,1,0,0,0,165.66,297.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,301.08a1,1,0,1,0-1,1A1,1,0,0,0,165.66,301.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,300.56a1,1,0,0,0-.56-1.84,1,1,0,0,0,.56,1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86,300.56a1,1,0,1,0-.56-1.84,1,1,0,1,0,.56,1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,335.24c-12.73-2.87-40.29-3.9-40.29-3.9-6.64.21-25.12,1-37.85,3.91a9.39,9.39,0,0,0-7.1,11.13l11.79,55.16a12,12,0,0,0,11.7,9.46H187.7a12,12,0,0,0,11.7-9.46l11.78-55.16A9.4,9.4,0,0,0,204,335.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,334.18c-13.81-2.06-34.46-2.84-34.46-2.84a281.4,281.4,0,0,0-30.22,2.5L146.88,411h36.31Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.36,
    y: 348.11,
    width: 38.48,
    height: 27.16,
    rx: 8.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.91,
    y: 359.3,
    width: 6.23,
    height: 6.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.48,
    y: 359.3,
    width: 6.23,
    height: 6.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.06,
    y: 359.3,
    width: 6.23,
    height: 6.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.06,393.56H187.9a5,5,0,0,1,5,5v62.27a0,0,0,0,1,0,0H72.06a0,0,0,0,1,0,0V398.56A5,5,0,0,1,77.06,393.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9,415.94c-15.18,3.85-30.76,13.65-59.79,27.45-28,13.32-50.92,13.09-61.05,12.06v5.38H192.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.06,
    y: 457.1,
    width: 120.84,
    height: 3.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,427.2a6.23,6.23,0,1,1-6.23-6.23A6.23,6.23,0,0,1,138.71,427.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotBro);
export default __webpack_public_path__ + "static/media/Chat bot-bro.456967210306bd4c3da03e2187536850.svg";
export { ForwardRef as ReactComponent };